<div class="modal fade show {{ customClassName }}" [ngClass]="{'visible' : visible, 'is-scrollable': scrollable}" role="dialog">
  <div class="modal-dialog modal-dialog-centered size-{{ ModalSize[size].toLowerCase() }}" role="document">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
